/**
 * Which TikTok this console writes to, named for a person about to write.
 *
 * The worker's smoke check answers `tiktok.target`, the host its calls actually
 * reach (docs/API-CONTRACT.md, GET /api/v1/smoke). Two hosts are known: TikTok's
 * sandbox and production, `TIKTOK_SANDBOX` and `TIKTOK_PRODUCTION` in
 * apps/worker/src/platform/tiktok.ts. Only those two get a label; any other host is
 * shown as itself, with no guess at what it is. `tiktok-host.test.ts` reads both
 * files as text, so the pair here cannot drift from them.
 */

export const SANDBOX_HOST = "sandbox-ads.tiktok.com";
export const PRODUCTION_HOST = "business-api.tiktok.com";

/** What the badge says while the smoke check has not answered, or failed. */
export const UNKNOWN_HOST = "TikTok host unknown";

export type TikTokHost =
	| { kind: "sandbox" | "production" | "other"; host: string; text: string }
	| { kind: "unknown"; host: null; text: string };

/** Exact host names only: a lookalike such as `business-api.tiktok.com.example` is "other". */
export function tiktokHost(target: string | null | undefined): TikTokHost {
	if (!target) return { kind: "unknown", host: null, text: UNKNOWN_HOST };
	if (target === SANDBOX_HOST)
		return { kind: "sandbox", host: target, text: `Sandbox · ${target}` };
	if (target === PRODUCTION_HOST) {
		return { kind: "production", host: target, text: `Production · ${target}` };
	}
	return { kind: "other", host: target, text: target };
}
